import Component from '../../js/_Component';
import Menu from '../../js/lib/_menu';
import '../../js/_ResizeObserver';

const CNAME = 'c-block-header-compact';

export default class BlockHeaderCompact extends Component {
	private hamburger: HTMLButtonElement;

	private menuElement: HTMLElement;

	private menu: Menu;

	constructor(element: HTMLElement) {
		super(element);

		this.hamburger = this.element.querySelector(`.${CNAME}--hamburger`);
		this.menuElement = this.element.querySelector(`.${CNAME}--menu`);
		this.menu = new Menu(this.menuElement, this.hamburger);

		this.menuElement.addEventListener('menuopen', () => {
		});

		this.menuElement.addEventListener('menuclose', () => {
		});

		this.menuElement.addEventListener('menuopened', () => {
			requestAnimationFrame(() => this.hideOtherMenus());
			requestAnimationFrame(() => this.toggleDarkenContent());

		});

		this.menuElement.addEventListener('menuclosed', () => {
			requestAnimationFrame(() => this.hideOtherMenus());
			requestAnimationFrame(() => this.toggleDarkenContent());
		});

		let observer = new ResizeObserver(() => this.closeMenusSize());
		observer.observe(this.element);
	}

	hideOtherMenus() {
		// If no menu is open, show all items.
		// If a menu is open, show only that.
		let openButton = this.menuElement.querySelector(`.${CNAME}--button[aria-expanded="true"]`);
		let allItems = this.menuElement.querySelectorAll(`.${CNAME}--item`) as NodeList;
		let utilityArea = this.menuElement.querySelector(`.${CNAME}--bottom-utility-wrapper`) as HTMLElement;

		if(openButton) {
			allItems.forEach(function(anItem: HTMLElement){
				if(anItem.querySelector(`.${CNAME}--button[aria-expanded="true"]`)){
					anItem.classList.remove('m-hide');
				} else {
					anItem.classList.add('m-hide');
				}
				utilityArea.classList.add('m-hide');
			});
		} else {
			allItems.forEach(function(anItem: HTMLElement){
				anItem.classList.remove('m-hide');
				utilityArea.classList.remove('m-hide');
			});
		}
	}

	toggleDarkenContent() {
		// Will darken other sections of the site if called
		// These selectors, and the css, are influencing things outside of the component.
		if(this.hamburger.getAttribute("aria-expanded") == "true") {
			document.querySelector('.site--main').classList.add('darken-background-from-header');
			document.querySelector('.c-block-footer-caf').classList.add('darken-background-from-header');
			document.querySelector('.c-block-anchor-subheader').classList.add('darken-background-from-header');
		} else {
			document.querySelector('.site--main').classList.remove('darken-background-from-header');
			document.querySelector('.c-block-footer-caf').classList.remove('darken-background-from-header');
			document.querySelector('.c-block-anchor-subheader').classList.remove('darken-background-from-header');
		}
	}

	closeMenusSize() {
		// If we're above 1280, close the mobile menu.
		// We need to do this because of the toggleDarkenContent() function adding dark backgrounds to everything.
		// Firefox will report a size of 0 if the event triggers when it is hidden
		if(this.element.offsetWidth > 1279 || this.element.offsetWidth == 0){
			this.menu.closeAllMenus();
		}
	}
}

Component.register(BlockHeaderCompact, 'BlockHeaderCompact');
